import { useQuery } from "@tanstack/react-query"
import { getDrawsByCategoryId } from "../../services/draw"

const useGetDrawsByCategoryId = (categoryId: number | undefined) => {
    return useQuery({
        queryKey: ['draws', categoryId],
        staleTime: Infinity,
        queryFn: () => getDrawsByCategoryId(categoryId ?? 0),
        enabled: !!categoryId
    });
};

export default useGetDrawsByCategoryId;